<script>
  export { className as class }

  let className = ""
</script>

<h1 class="{className} page-title [ text-5xl sm:text-6xl ]">
  <slot />
</h1>
